<template>
  <div>
    <el-upload
      :action="envUrl + 'api/business/file/upload'"
      :accept="accept"
      :file-list="fileList"
      :limit="limit"
      ref="upload"
      :on-remove="handleRemove"
      :disabled="disabled"
      :on-success="handleSuccess"
      class="upload-demo"
      :headers="headers"
      :auto-upload="false"
      :data="{ customerId: customerId, fileCategory: fileCategory }"
    >
      <el-button :loading="uploadLoading" size="small" :disabled="disabled">
        <i class="el-icon-upload el-icon--right"></i> {{ btnTxt }}
      </el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "UploadBtn",
  props: {
    accept: {
      type: String,
      default: ".png,.jpg,.jpge,.pdf,.svg,.webp,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rar,.zip,.7z,.gz,.tar,.xml,.json,.md,.css,.js,.ts,.java,.py,.go,.c,.h,.cpp,.hpp,.m,.mm,.java,.kt,.swift,.php,.rb,.rbx,.lua,.v,.vhdl,.verilog,.sql,.pl,.ps1,.psm1,.ps",
    },
    customerId: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 1,
    },

    btnTxt: {
      type: String,
      default: "点击上传",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fileCategory: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      uploadLoading: false,
      envUrl: process.env.VUE_APP_BASE_API,
       headers: {
        Authorization: localStorage.getItem("token")
      },
    };
  },

  computed: {
    fileList: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleSuccess(e) {
      if (e.status == 200) {
        this.$notify({
          message: "操作成功!",
          type: "success",
        });
        this.$emit("onSuccess");
      } else {
        this.$notify({
          message: e.message || "操作失败",
          type: "warning",
        });
      }
    },

    hanldeCLick() {
      this.$refs.upload.submit();
    },

    /**
     * 删除文件
     * @param {Object} file      删除的当前文件信息
     * @param {Object} fileList  文件列表
     */
    handleRemove(file, fileList) {
      let index = this.fileList.findIndex((item) => {
        return item.path === file.path;
      });
      this.fileList.splice(index, 1);
    },

    handlePreview(e) {
      window.open(e.path);
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #606266;
  font-size: 14px;
}
img {
  height: 500px;
}
::v-deep .el-upload-list__item:first-child {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
  width: 166px;
}
::v-deep .el-upload-list__item-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
  width: 126px;
}
</style>
